import { Helmet } from 'react-helmet-async';
import { forwardRef } from 'react';
import {
  useLocation,
  useNavigate
} from "react-router-dom";

import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useIntl } from 'react-intl';
import SeoLayout from './SeoLayout';

interface Props {
  children: React.ReactNode | React.ReactElement | React.ReactNode[] | React.ReactElement[];
  meta?: any;
  title?: string;
  hideToolbar?: boolean
  isList?: boolean
  onCreate?: () => void;
  createUrl?: string;
  buttonComponent?: React.ReactNode | React.ReactElement | React.ReactNode[] | React.ReactElement[];
}

const PageLayout = forwardRef(({ children, isList, title, hideToolbar, createUrl, meta, onCreate, buttonComponent, ...other }: Props, ref: any) => {
  const { formatMessage } = useIntl();
  const nagivate = useNavigate();
  let match = useLocation();
  const url = createUrl ? createUrl : `${match.pathname}/create`;
  return <>
    <SeoLayout
      title={title}
      meta={meta}
    />
    <Box ref={ref} {...other}>
      <Container maxWidth="xl" style={{ maxWidth: '100%' }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          {title ?
            <Typography variant="h5" gutterBottom textTransform='uppercase'>
              {title} {isList && formatMessage({ id: "list" })}
            </Typography>
            : <Box></Box>}
          {!hideToolbar && <Box sx={{ display: 'flex', gap: 2 }}>
            <Button variant="contained" onClick={() => onCreate ? onCreate() : nagivate(url)} startIcon={<Add />}>
              Create
            </Button>
            {buttonComponent}
          </Box>
          }
        </Stack>
        {children}
      </Container>
    </Box>
  </>
});

PageLayout.defaultProps = {
  title: '',
  hideToolbar: false,
  isList: true
}

export default PageLayout;
